<template>
    <div :id="svgId" class="svg-container"></div>
</template>

<script>
import usaMap from './maps/usa'
import stateOverrides from './state_overrides'

export default {
    name: "CampingMap",
    props: {
        id: {
            default: "campingMap"
        },
        svgViewboxWidth: {
            default: 1000
        },
        svgViewboxHeight: {
            default: 600
        },
        width: {
            default: '100%'
        },
        height: {
            default: '100%'
        },
        stateData: {
            default: []
        },
        unvisitedStateColor: {
            default: "white"
        },
        outlineColor: {
            default: "#999"
        },
        outlineWidth: {
            default: 1
        },
        ignoreColors: {
            default: ["000000", "ffffff", "d3d3d3"]
        }
    },
    data () {
        return {
            svgId: this.id,
            viewboxWidth: this.svgViewboxWidth,
            viewboxHeight: this.svgViewboxHeight,
            defaultFormatting: {
                "fill": this.unvisitedStateColor,
                "stroke": this.outlineColor,
                "stroke-width": this.outlineWidth, 
            },
            colorsUsed: [],
            colorsIgnored: this.ignoreColors
        }
    },
    mounted () {
        this.generateMap()
    },
    methods: {
        generateMap () {
            const mapData = usaMap.g.path
            const svgContainer = this.$svg(this.svgId).size(this.width, this.height).viewbox(0, 0, this.viewboxWidth, this.viewboxHeight)
            mapData.forEach((pathObj) => {
                this.generatePath(svgContainer, pathObj)
            })
        },
        generatePath(svgCont, pathObj) {
            const vue = this
            const state = pathObj['title']
            const element = svgCont.path(pathObj["-d"]).attr(this.getStateAttrs(pathObj))
            this.generateVisitCountText(state, svgCont, element.bbox())
            
            element.click(function () {
                const mapId = this.node.attributes["map-id"].value
                const title = this.node.attributes["title"].value
                vue.$emit("map-clicked", { mapId, title })
            })
        },
        generateVisitCountText(state, svgCont, bbox) {
            if(!this.visitedState(state) || !('count' in this.getDataForState(state)))
                return 

            svgCont.text(this.numberOfTimesStateVisited(state).toString()).attr({
                fill: 'white',
                x: this.stateHasTextOverrides(state) ? stateOverrides[state].text_x(bbox.cx) : bbox.cx,
                y: this.stateHasTextOverrides(state) ? stateOverrides[state].text_y(bbox.cy) : bbox.cy,
            })
        },
        getStateAttrs(pathObj) {
            const stateName = pathObj['title']
            const stateData = this.getDataForState(stateName)
            let attrs = {
                ...this.defaultFormatting,
                'title': stateName,
                'map-id': pathObj["-id"],
            } 
            if(this.visitedState(stateName)) {
                if('color' in stateData) {
                    attrs['fill'] = stateData.color
                    this.colorsUsed.push(stateData.color)
                } else {
                    attrs['fill'] = this.getUnusedColor()
                }
            }
            return attrs
        },
        getDataForState(stateName) {
            return this.stateData.find(s => s.state == stateName)
        },
        stateHasTextOverrides(state) {
            return Object.keys(stateOverrides).includes(state)
        },
        visitedState(stateName) {
            return !!this.getDataForState(stateName)
        },
        numberOfTimesStateVisited(stateName) {
            let stateObj = this.getDataForState(stateName)
            if(!stateObj) return 0
            return stateObj.count
        },
        randomColor() {
            let color = Math.round(0xffffff * Math.random()).toString(16)
            let diff = (6 - color.length)
            let mask = "000000"
            return mask.substring(0, diff) + color
        },
        getUnusedColor() {
            let color = this.randomColor()
            while(this.colorsIgnored.includes(color) || this.colorsUsed.includes(color)) {
                color = this.randomColor()
            }
            this.colorsUsed.push(color)
            return '#'+color
        }
    }
}
</script>
